import React from 'react';
import CallPerformance from './CallPerformance';

// Helper function to format duration
const formatDuration = (duration) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  return `${hours}h ${minutes}m ${seconds}s`;
};
const getBackgroundColor = (fullName) => {
  if (!fullName) return "gray"; // Default color for unknown names
  const firstChar = fullName.charAt(0).toUpperCase();
  const colors = {
    A: "DodgerBlue",
    B: "Tomato",
    C: "Gold",
    D: "MediumSeaGreen",
    E: "SlateBlue",
    F: "Violet",
    G: "LightCoral",
    H: "Orange",
    I: "Teal",
    J: "Crimson",
    K: "Indigo",
    L: "DarkOrange",
    M: "CornflowerBlue",
    N: "SeaGreen",
    O: "RoyalBlue",
    P: "Salmon",
    Q: "DarkCyan",
    R: "Sienna",
    S: "DarkMagenta",
    T: "FireBrick",
    U: "SteelBlue",
    V: "DarkSlateBlue",
    W: "MediumPurple",
    X: "Olive",
    Y: "DarkGoldenRod",
    Z: "Maroon",
  };
  return colors[firstChar] || "gray"; // Fallback color
};

// Top Callers Report
const columnsTopCallers = [
  {
    name: <span className="font-weight-bold fs-13">S No</span>,
    selector: (row, index) => index + 1,
    sortable: false,
    width: '80px',
  },
  {
    name: <span className="font-weight-bold fs-13">Employee Name</span>,
    selector: row => row.fullName,
    cell: row => (
      <div className="d-flex align-items-center">
        {row.profileImageUrl ? (
          <img
            src={row.profileImageUrl}
            alt="Profile"
            style={{
              width: "35px",
              height: "35px",
              objectFit: "cover",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
        ) : (
          <div
            className="rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: "35px",
              height: "35px",
              // background: "DodgerBlue",
              background: getBackgroundColor(row.fullName),
              marginRight: "10px",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {row.fullName ? row.fullName.charAt(0).toUpperCase() : '?'}
          </div>
        )}
        <span>{row.fullName || 'Unknown'}</span>
      </div>



    ),
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Name</span>,
    selector: row => row.team_ranks[0]?.team || "-",
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">(Incoming+Outgoing)</span>,
    selector: row => row.callCount,
    sortable: true,
  },{
    name: <span className="font-weight-bold fs-13">Organizational Rank</span>,
    selector: (row) => row.overall_rank,
    cell: (row) => <span>{row.overall_rank || "-"}</span>,
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Rank</span>,
    selector: (row) => row.team_ranks,
    cell: (row) => (
      <div>
        {row.team_ranks && row.team_ranks.length > 0 ? (
          <div>
            {row.team_ranks[0]?.team_rank}
          </div>
        ) : (
          "-"
        )}
      </div>
    ),
  }
  ,
];

// Top Dialers Report
const columnsTopDialers = [
  {
    name: <span className="font-weight-bold fs-13">S No</span>,
    selector: (row, index) => index + 1,
    sortable: false,
    width: '80px',
  },
  {
    name: <span className="font-weight-bold fs-13">Employee Name   </span>,
    selector: row => row.fullName,
    cell: row => (
      <div className="d-flex align-items-center">
        {row.profileImageUrl ? (
          <img
            src={row.profileImageUrl}
            alt="Profile"
            style={{
              width: "35px",
              height: "35px",
              objectFit: "cover",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
        ) : (
          <div
            className="rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: "35px",
              height: "35px",
              background: getBackgroundColor(row.fullName),
              marginRight: "10px",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {row.fullName ? row.fullName.charAt(0).toUpperCase() : '?'}
          </div>
        )}
        <span>{row.fullName || 'Unknown'}</span>
      </div>
    ),
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Name</span>,
    selector: row => row.team_ranks[0]?.team || "-",
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Total Outgoing Calls</span>,
    selector: row => row.totalOutgoing || 0,
    sortable: true,
  },
  ,{
    name: <span className="font-weight-bold fs-13">Organizational Rank</span>,
    selector: (row) => row.overall_rank,
    cell: (row) => <span>{row.overall_rank || "-"}</span>,
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Rank</span>,
    selector: (row) => row.team_ranks,
    cell: (row) => (
      <div>
        {row.team_ranks && row.team_ranks.length > 0 ? (
          <div>
            {row.team_ranks[0]?.team_rank}
          </div>
        ) : (
          "-"
        )}
      </div>
    ),
  }
  ,
];

// Top Connected Report
const columnsTopConnected = [
  {
    name: <span className="font-weight-bold fs-13">S No</span>,
    selector: (row, index) => index + 1,
    sortable: false,
    width: '80px',
  },
  {
    name: <span className="font-weight-bold fs-13">Employee Name</span>,
    selector: row => row.fullName,
    cell: row => (
      <div className="d-flex align-items-center">
        {row.profileImageUrl ? (
          <img
            src={row.profileImageUrl}
            alt="Profile"
            style={{
              width: "35px",
              height: "35px",
              objectFit: "cover",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
        ) : (
          <div
            className="rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: "35px",
              height: "35px",
              background: getBackgroundColor(row.fullName),
              marginRight: "10px",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {row.fullName ? row.fullName.charAt(0).toUpperCase() : '?'}
          </div>
        )}
        <span>{row.fullName || 'Unknown'}</span>
      </div>
    ),
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Name</span>,
    selector: row => row.team_ranks[0]?.team || "-",
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Total Answered Calls</span>,
    selector: row => row.totalAnswered || 0,
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Organizational Rank</span>,
    selector: (row) => row.overall_rank,
    cell: (row) => <span>{row.overall_rank || "-"}</span>,
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Rank</span>,
    selector: (row) => row.team_ranks,
    cell: (row) => (
      <div>
        {row.team_ranks && row.team_ranks.length > 0 ? (
          <div>
             {row.team_ranks[0]?.team_rank}
          </div>
        ) : (
          "-"
        )}
      </div>
    ),
  }
  ,
];

const columnsTopDuration = [
  {
    name: <span className="font-weight-bold fs-13">S No</span>,
    selector: (row, index) => index + 1,
    sortable: false,
    width: '80px',
  },
  {
    name: <span className="font-weight-bold fs-13">Employee Name</span>,
    selector: row => row.fullName,
    cell: row => (
      <div className="d-flex align-items-center">
        {row.profileImageUrl ? (
          <img
            src={row.profileImageUrl}
            alt="Profile"
            style={{
              width: "35px",
              height: "35px",
              objectFit: "cover",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
        ) : (
          <div
            className="rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: "35px",
              height: "35px",
              background: getBackgroundColor(row.fullName),
              marginRight: "10px",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {row.fullName ? row.fullName.charAt(0).toUpperCase() : '?'}
          </div>
        )}
        <span>{row.fullName || 'Unknown'}</span>
      </div>
    ),
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Name</span>,
    selector: row => row.team_ranks[0]?.team || "-",
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Total Duration</span>,
    selector: row => row.totalDuration || 0,
    cell: row => <span>{formatDuration(row.totalDuration || 0)}</span>,
    sortable: true,
  },{
    name: <span className="font-weight-bold fs-13">Organizational Rank</span>,
    selector: (row) => row.overall_rank,
    cell: (row) => <span>{row.overall_rank || "-"}</span>,
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Team Rank</span>,
    selector: (row) => row.team_ranks,
    cell: (row) => (
      <div>
        {row.team_ranks && row.team_ranks.length > 0 ? (
          <div>
            {row.team_ranks[0]?.team_rank}
          </div>
        ) : (
          "-"
        )}
      </div>
    ),
  }
  ,
];

export const TopCallersReport = () => {
  return (
    <CallPerformance title="Top Caller" columns={columnsTopCallers} sortKey="callCount" headerName = 'Employee with the highest total calls (incoming and outgoing)' />
  );
};
 
export const TopDialersReport = () => {
  return (
    <CallPerformance title="Top Dialer" columns={columnsTopDialers}  headerName = 'Employee with the most outgoing calls .' sortKey="totalOutgoing"/>
  );
};
 
export const TopConnectedReport = () => {
  return (
    <CallPerformance title="Top Answered" columns={columnsTopConnected} headerName = 'Employee who received and answered the highest number of calls.' sortKey="totalAnswered"/>
  );
};
 
export const TopDurationReport = () => {
  return (
    <CallPerformance title="Highest Call Duration" columns={columnsTopDuration}  headerName = 'Employee with the longest cumulative call time  across all calls.' sortKey="totalDuration"/>
  );
};
